import CollaborateHero from "./components/CollaborateHero";
import CollaborateWays from "./components/CollaborateWays";
import CollaborateProcess from "./components/CollaborateProcess";
import CollaborateForm from "./components/CollaborateForm";
import CollaborateTrust from "./components/CollaborateTrust";

export default function Collaborate() {
  return (
    <main className="min-h-screen">
      <CollaborateHero />
      <CollaborateWays />
      <CollaborateProcess />
      <CollaborateForm />
      <CollaborateTrust />
    </main>
  );
}